import { openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

export const useStationsController = () => {
  const onEditStation = (stationId: string) => {
    openModal(MODAL_KEY.ADD_STATION, { id: stationId });
  };

  return {
    onEditStation,
  };
};
